/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var config = require('../config');

module.exports = function () {
    function PPT() {
        var _this = this;

        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3["default"])(this, PPT);

        _scope.Feature.EventBus(this);

        param.config = param.config || {};

        // var hasCurrentDoc = typeof param.config.current_doc === 'object';

        this.id = param.act_id;
        this.config = {
            current_doc: '', // docId hash string
            current_page: 0,
            is_turn_page: false,
            name: '',
            open: false,
            url: '',
            total_page: 0,
            images: []
        };
        this.actHashId = param.actHashId;

        this.isPptInfoInited = false;
        this.isPptConfigInited = false;
        this.isPptIntranetInited = false;
        this.isPptInited = false;
        this.isIntranet = false;
        this.customURL = '';

        this._fetchInitPptData(this._listenInitOver.bind(this, 'isPptInfoInited'));
        this._fetchPptSwitcher();
        this._fetchConfigPptData(this._listenInitOver.bind(this, 'isPptConfigInited'));
        this._fetchSpecificDocUrl(this._listenInitOver.bind(this, 'isPptIntranetInited'));
        this._ropPptChange();
        _scope.MsgBus.On('IntranetStream', function () {
            // 联想定制SDK:使用内网拉流地址时，文档返回的图片域名替换成指定域名
            _this.isIntranet = true;
        });
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(PPT, [{
        key: '_listenInitOver',
        value: function _listenInitOver(param) {
            if (param === 'isPptInfoInited' || param === 'isPptConfigInited' || param === 'isPptIntranetInited') {
                this[param] = true;

                if (this.isPptInfoInited && this.isPptConfigInited && this.isPptIntranetInited) {
                    this.isPptInited = true;
                    _scope.MsgBus.Pub('PPT.Inited.Over');
                }
            }
        }
    }, {
        key: '_fetchInitPptData',
        value: function _fetchInitPptData(cb) {
            var _self = this;
            var actHashId = this.actHashId;
            var url = config.API_DOMAIN + '/docs/api/activities/' + actHashId + '/documents/now?time=' + new Date().getTime();
            Fetcher.Get(url, function (data, code) {
                try {
                    data = JSON.parse(data);
                    if (code !== 200) {
                        console.log('fetch ppt info failed.'); // eslint-disable-line
                        throw new Error(code);
                    }

                    if (data.errcode !== 1000) {
                        console.log('something wrong with ppt info.'); // eslint-disable-line
                        throw new Error(data.errcode);
                    }
                    _self.config.current_doc = data.doc_id;
                    _self.config.current_page = data.index;
                    _self.config.url = (data.images[data.index] ? data.images[data.index].url : '') || '';
                    _self.config.total_page = data.images.length;
                    _self.config.images = data.images;
                    typeof cb === 'function' && cb();
                } catch (err) {
                    typeof cb === 'function' && cb();
                    _scope.MsgBus.Pub('PPT.Init.Error', err);
                    _scope.MsgBus.Pub('Room.Init.Error', err);
                }
            });
        }
    }, {
        key: '_fetchPptSwitcher',
        value: function _fetchPptSwitcher() {
            var _self = this;
            var actHashId = this.actHashId;
            var url = config.API_DOMAIN_V2 + '/v2/micro-act/view/module_switch?module_id=' + config.MENU_TYPE.DOC + '&act_id=' + actHashId;
            Fetcher.Get(url, function (data, code) {
                try {
                    data = JSON.parse(data);
                    if (code !== 200) {
                        console.log('fetch ppt switcher failed.'); // eslint-disable-line
                        throw new Error(code);
                    }
                    if (data.errcode !== 1000) {
                        console.log('something wrong with ppt switcher.'); // eslint-disable-line
                        throw new Error(data.errcode);
                    }
                    _self.config.open = data.is_open;
                } catch (err) {
                    _scope.MsgBus.Pub('PPT.Init.Error', err);
                }
            }, _scope.DB.Get('requestHeader').session);
        }
    }, {
        key: '_fetchConfigPptData',
        value: function _fetchConfigPptData(cb) {
            var _self = this;
            var actHashId = this.actHashId;
            var url = config.API_DOMAIN + '/docs/api/activities/' + actHashId + '/config';
            Fetcher.Get(url, function (data, code) {
                try {
                    data = JSON.parse(data);
                    if (code !== 200) {
                        console.log('fetch ppt config failed.'); // eslint-disable-line
                        throw new Error(code);
                    }
                    if (data.errcode !== 1000) {
                        console.log('something wrong with ppt config.'); // eslint-disable-line
                        throw new Error(data.errcode);
                    }
                    _self.config.name = data.name;
                    _self.config.is_turn_page = data.turn;
                    // _self.config.open = data.open;
                    typeof cb === 'function' && cb();
                } catch (err) {
                    typeof cb === 'function' && cb();
                    _scope.MsgBus.Pub('PPT.Init.Error', err);
                    _scope.MsgBus.Pub('Room.Init.Error', err);
                }
            });
        }
    }, {
        key: '_ropPptChange',
        value: function _ropPptChange() {
            var _self = this;
            var actHashId = this.actHashId;
            rop.On('app.mududoc.sync.' + actHashId, function (data) {
                data = JSON.parse(data);
                if (data.type === 'config') {
                    _self._handleConfigChange(data);
                } else if (data.type === 'doc') {
                    _self._handleDocChange(data);
                }
            });
            rop.On('mudu.menu.' + actHashId, function (data) {
                data = JSON.parse(data);
                if (data.type === 'menu.switch') {
                    switch (data.data.menu_type) {
                        case config.MENU_TYPE.DOC:
                            _self.config.open = data.data.is_turn_on;
                            var res = {
                                open: data.data.is_turn_on ? 1 : 0
                            };
                            if (res.open === 1) {
                                res.page = _self.config.current_page + 1;
                                res.total_page = _self.config.total_page;
                                res.url = _self._transformImageUrl(_self.config.url);
                            }
                            _scope.MsgBus.Pub('PPT.IsOpen', (0, _stringify2["default"])(res));
                            break;
                    }
                }
            });
        }
    }, {
        key: 'UnSubPPTTopics',
        value: function UnSubPPTTopics() {
            rop.Remove('app.mududoc.sync.' + this.actHashId);
            rop.Remove('mudu.menu.' + this.actHashId);
        }
    }, {
        key: '_handleDocChange',
        value: function _handleDocChange() {
            var newDoc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var _self = this;
            var config = this.config;
            if (!newDoc.url) {
                this.config = (0, _assign2["default"])({}, config, {
                    current_doc: '', // docId hash string
                    current_page: 0,
                    name: '',
                    url: '',
                    total_page: 0,
                    images: []
                });
                _scope.MsgBus.Pub('PPT.Doc.delete');
            } else if (newDoc.docid === this.config.current_doc) {
                // 同一文档
                this.config.current_page = newDoc.index;
                this.config.url = newDoc.url;
                var res = {
                    page: newDoc.index + 1,
                    url: _self._transformImageUrl(newDoc.url),
                    total_page: config.total_page
                };
                _scope.MsgBus.Pub('PPT.Changed', (0, _stringify2["default"])(res));
            } else {
                this._fetchInitPptData(function () {
                    var _config = _self.config;
                    var res2 = {
                        page: _config.current_page + 1,
                        url: _self._transformImageUrl(_config.url),
                        total_page: _config.total_page
                    };
                    _scope.MsgBus.Pub('PPT.Changed', (0, _stringify2["default"])(res2));
                });
            }
        }
    }, {
        key: '_handleConfigChange',
        value: function _handleConfigChange() {
            var newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.config.name = newConfig.name;
            var config = this.config;
            if (newConfig.turn !== config.is_turn_page) {
                this.config.is_turn_page = newConfig.turn;
                var res2 = {
                    is_turn_page: newConfig.turn ? 1 : 0,
                    current_page: config.current_page + 1,
                    total_page: config.total_page,
                    url: this._transformImageUrl(config.url)
                };
                _scope.MsgBus.Pub('PPT.AllowTurnPage', (0, _stringify2["default"])(res2));
            }
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this2 = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                rop.Remove('app.mududoc.sync.' + _this2.actHashId);
                rop.Remove('mudu.menu.' + _this2.actHashId);

                _scope.MsgBus.UnSubAll('PPT.Changed');
                _scope.MsgBus.UnSubAll('PPT.Doc.delete');
                _scope.MsgBus.UnSubAll('PPT.IsOpen');
                _scope.MsgBus.UnSubAll('PPT.AllowTurnPage');

                _scope.MsgBus.UnSub(_this2.destroyKey);
            });
        }
    }, {
        key: '_fetchSpecificDocUrl',
        value: function _fetchSpecificDocUrl(cb) {
            var _self = this;
            var url = config.API_DOMAIN + '/activity/v1/ecdn/ppt';
            Fetcher.Get(url, function (data, code) {
                try {
                    data = JSON.parse(data);
                    if (code !== 200) {
                        console.log('fetch ecdn ppt failed.'); // eslint-disable-line
                        throw new Error(code);
                    }
                    if (data.errcode !== 1000) {
                        console.log('something wrong with config  ppt.'); // eslint-disable-line
                        throw new Error(data.errcode);
                    }
                    _self.customURL = data.data.address;
                    typeof cb === 'function' && cb();
                } catch (err) {
                    typeof cb === 'function' && cb();
                    _scope.MsgBus.Pub('PPT.Init.Error', err);
                }
            });
        }
    }, {
        key: '_transformImageUrl',
        value: function _transformImageUrl(url) {
            // 拿到domain就改
            if (this.customURL) {
                var reg = /^http(s)?:\/\/(.*?)\//;
                var host = reg.exec(url)[2];
                return url.replace(host, this.customURL);
            }
            return url;
        }
        // 获取当前ppt地址

    }, {
        key: 'GetUrl',
        value: function GetUrl() {
            return this._transformImageUrl(this.config.url);
        }

        // 获取ppt是否打开

    }, {
        key: 'IsOpen',
        value: function IsOpen() {
            return this.config.open;
        }

        // 获取ppt的名称

    }, {
        key: 'GetName',
        value: function GetName() {
            return this.config.name || '';
        }

        // 获取用户是否能翻页

    }, {
        key: 'GetAllowTurnPage',
        value: function GetAllowTurnPage() {
            return this.config.is_turn_page;
        }

        // 获取当前页

    }, {
        key: 'GetCurrentPage',
        value: function GetCurrentPage() {
            return this.config.current_page + 1;
        }

        // 获取总页数

    }, {
        key: 'GetTotalPage',
        value: function GetTotalPage() {
            return this.config.total_page;
        }

        // 根据页码获取图片url

    }, {
        key: 'GetPageImgUrl',
        value: function GetPageImgUrl(page, cb) {
            var dealedPage = +page - 1;
            var obj = this.config.images[dealedPage];
            var url = (obj ? this._transformImageUrl(obj.url) : '') || '';
            typeof cb === 'function' && cb(url);
        }
    }]);
    return PPT;
}();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/PPT.js
 ** module id = 170
 ** module chunks = 1
 **/